export const NAVIGATION = 'cp_navigation'
export const FILES = 'cp_files'
export const AXIOS_ERROR_MESSAGE = 'cp_axios_error_message'
export const COPY_TO_CLIPBOARD = 'cp_copy_to_clipboard'
export const MUI_GRID = 'cp_mui_grid'
export const TABLE_COMPONENT = 'cp_table';
export const CONFIRMATION = 'cp_confirmation';
export const GRID_STATE = 'cp_grid_state'
export const EDITABLE_MUI_GRID = 'cp_editable_mui_grid'
export const EDITABLE_MUI_GRID_AS_FIELD = 'cp_editable_mui_grid_as_field'